export default __webpack_public_path__ + "static/media/white01.08e6383d.jpg";